(function() {
    'use strict';
    // console.log('[QB Custom] JS cargado');
    let quantityBreaks = [];
    let initializedTable = null;
    /*
     * ============================================================
     * BUSCAR TABLA QUANTITY BREAKS
     * ============================================================
     */
    function findQuantityBreaksTable() {
        const wrapper = document.querySelector('[data-testid="qb-table-layout"]');
        if (!wrapper) {
            return null;
        }
        const table = wrapper.querySelector('table');
        if (!table) {
            return null;
        }
        return table;
    }
    /*
     * ============================================================
     * INICIALIZACIÓN
     * ============================================================
     */
    function init(table) {
        // console.log('[QB Custom] init()');
        // Evitar inicializar dos veces la misma tabla
        if (!table || initializedTable === table) {
            // console.log('[QB Custom] Tabla ya inicializada');
            return;
        }
        initializedTable = table;
        quantityBreaks = readQuantityBreaks(table);
        // console.log('[QB Custom] Tramos encontrados:', quantityBreaks);
        if (!quantityBreaks.length) {
            // console.log('[QB Custom] No se encontraron tramos');
            return;
        }
        /*
         * Corregir los totales de Quantity Breaks
         */
        fixTableTotals();
        /*
         * Escuchar cambios de cantidad
         */
        bindQuantityInput();
        /*
         * Actualizar inicialmente
         */
        updateActiveBreak();
        observeCartQuantity();
        setTimeout(function() {
            // console.log('[QB Custom] Verificación tardía de cantidad');
            updateActiveBreak();
        }, 500);
    }
    /*
     * ============================================================
     * LEER TABLA
     * ============================================================
     */
    function readQuantityBreaks(table) {
        const breaks = [];
        table.querySelectorAll('tr').forEach(function(row) {
            const cells = row.querySelectorAll('td');
            // Saltar encabezado
            if (cells.length < 4) {
                return;
            }
            const quantityText = cells[0].textContent.trim();
            const discountText = cells[1].textContent.trim();
            const priceText = cells[2].textContent.trim();
            /*
             * Ejemplo:
             *
             * Desde 222 Un.
             *
             * Resultado:
             *
             * 222
             */
            const quantityMatch = quantityText.match(/(\d+)/);
            if (!quantityMatch) {
                return;
            }
            const quantity = parseInt(quantityMatch[1], 10);
            const price = normalizePrice(priceText);
            const discount = parseFloat(discountText.replace('%', '').replace(',', '.')) || 0;
            if (!Number.isNaN(quantity) && !Number.isNaN(price)) {
                breaks.push({
                    quantity: quantity,
                    price: price,
                    discount: discount,
                    row: row
                });
            }
        });
        return breaks.sort(function(a, b) {
            return a.quantity - b.quantity;
        });
    }
    /*
     * ============================================================
     * NORMALIZAR PRECIO
     * ============================================================
     */
    function normalizePrice(value) {
        // if (typeof value === 'number') {
        //     return value;
        // }
        // return Number(String(value).replace(/\$/g, '').replace(/CLP/gi, '').replace(/\./g, '').replace(/,/g, '.').trim());
         if (typeof value === 'number') {
            return value;
        }

        const normalized = String(value)
            .replace(/[^\d]/g, '');

        if (!normalized) {
            return NaN;
        }

        return Number(normalized);
    }
    /*
     * ============================================================
     * FORMATEAR PRECIO
     * ============================================================
     */
    function formatPrice(value) {
        return '$' + Math.round(value).toLocaleString('es-CL');
    }
    /*
     * ============================================================
     * OBTENER TRAMO ACTIVO
     * ============================================================
     */
    function getActiveBreak(quantity) {
        let activeBreak = null;
        quantityBreaks.forEach(function(item) {
            if (quantity >= item.quantity) {
                activeBreak = item;
            }
        });
        return activeBreak;
    }
    /*
     * ============================================================
     * CORREGIR TOTAL DE LA TABLA
     *
     * Total = cantidad × precio unitario
     * ============================================================
     */
    function fixTableTotals() {
        // console.log('[QB Custom] Corrigiendo totales de tabla');
        quantityBreaks.forEach(function(item) {
            const total = item.quantity * item.price;
            const cells = item.row.querySelectorAll('td');
            if (cells.length < 4) {
                return;
            }
            const totalCell = cells[3];
            const money = totalCell.querySelector('.money');
            if (money) {
                money.textContent = formatPrice(total);
            } else {
                totalCell.textContent = formatPrice(total);
            }
            // console.log('[QB Custom] Total:', item.quantity, '×', item.price, '=', total);
        });
    }
    /*
     * ============================================================
     * ESCUCHAR INPUT DE CANTIDAD
     * ============================================================
     */
    function bindQuantityInput() {
        const inputs = document.querySelectorAll('.qty_inpt2');
        // console.log('[QB Custom] Inputs encontrados:', inputs.length);
        inputs.forEach(function(input) {
            if (input.dataset.qbCustomBound === 'true') {
                return;
            }
            input.dataset.qbCustomBound = 'true';
            input.addEventListener('input', updateActiveBreak);
            input.addEventListener('change', updateActiveBreak);
        });
    }
    /*
     * ============================================================
     * OBSERVER CANTIDAD DEL CARRITO
     * ============================================================
     */
    function observeCartQuantity() {
        const container = document.querySelector('.product-form__payment-container');
        if (!container) {
            // console.log('[QB Custom] No existe payment-container todavía');
            return;
        }
        // console.log('[QB Custom] Iniciando observer de cantidad del carrito');
        /*
         * Evitar crear el observer más de una vez
         */
        if (container.dataset.qbCartObserver === 'true') {
            // console.log('[QB Custom] Observer ya existe');
            return;
        }
        container.dataset.qbCartObserver = 'true';
        /*
         * Guardamos la última cantidad procesada.
         *
         * Esto es MUY importante para evitar loops.
         */
        let lastCartQuantity = null;

        function checkCartQuantity() {
            const cartInput = container.querySelector('.qty_inpt');
            /*
             * Si todavía no existe el selector del carrito,
             * no hacemos nada.
             */
            if (!cartInput) {
                return;
            }
            const currentValue = parseInt(cartInput.dataset.currentValue || cartInput.value || '0', 10) || 0;
            /*
             * Si la cantidad no cambió realmente,
             * no volvemos a ejecutar updateActiveBreak().
             */
            if (currentValue === lastCartQuantity) {
                return;
            }
            lastCartQuantity = currentValue;
            // console.log('[QB Custom] Cambio REAL detectado en cantidad del carrito:', currentValue);
            /*
             * Esperamos un pequeño instante para que el tema
             * termine de actualizar todos sus elementos.
             */
            setTimeout(function() {
                /*
                 * Volvemos a comprobar que la cantidad siga siendo
                 * la misma antes de actualizar.
                 */
                const latestInput = container.querySelector('.qty_inpt');
                if (!latestInput) {
                    return;
                }
                const latestValue = parseInt(latestInput.dataset.currentValue || latestInput.value || '0', 10) || 0;
                if (latestValue !== lastCartQuantity) {
                    return;
                }
                updateActiveBreak();
            }, 50);
        }
        const observer = new MutationObserver(function(mutations) {
            let shouldCheck = false;
            mutations.forEach(function(mutation) {
                /*
                 * ====================================================
                 * NUEVOS ELEMENTOS
                 * ====================================================
                 *
                 * Shopify / Theme puede crear el selector del carrito
                 * dinámicamente.
                 */
                if (mutation.type === 'childList') {
                    if (mutation.addedNodes && mutation.addedNodes.length) {
                        shouldCheck = true;
                    }
                }
                /*
                 * ====================================================
                 * CAMBIO REAL DE CANTIDAD
                 * ====================================================
                 *
                 * Solo nos interesan estos atributos.
                 */
                if (mutation.type === 'attributes') {
                    if (mutation.attributeName === 'data-current-value') {
                        shouldCheck = true;
                    }
                    /*
                     * El theme también puede cambiar value.
                     *
                     * Lo mantenemos porque algunos componentes
                     * actualizan value y no data-current-value.
                     */
                    if (mutation.attributeName === 'value') {
                        shouldCheck = true;
                    }
                }
            });
            if (!shouldCheck) {
                return;
            }
            checkCartQuantity();
        });
        observer.observe(container, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-current-value', 'value']
        });
        /*
         * Revisar inmediatamente por si el selector
         * ya existe cuando iniciamos el observer.
         */
        checkCartQuantity();
    }
    /*
     * ============================================================
     * ACTUALIZAR TRAMO
     * ============================================================
     */
    function updateActiveBreak() {
        const input = document.querySelector('.minimum-quantity-wrapper .qty_inpt2');
        const cartQuantity = getCartQuantity();
        let quantity = 0;
        /*
         * ============================================================
         * PRODUCTO YA ESTÁ EN EL CARRITO
         * ============================================================
         */
        if (cartQuantity > 0) {
            quantity = cartQuantity;
            // console.log('[QB Custom] Producto ya está en carrito');
        }
        /*
         * ============================================================
         * PRODUCTO NUEVO
         * ============================================================
         */
        else if (input) {
            quantity = parseInt(input.value, 10);
            // console.log('[QB Custom] Producto todavía no está en carrito');
        }
        if (Number.isNaN(quantity) || quantity <= 0) {
            // console.log('[QB Custom] Cantidad inválida:', quantity);
            return;
        }
        /*
         * Buscar tramo
         */
        const activeBreak = getActiveBreak(quantity);
        if (!activeBreak) {
            // console.log('[QB Custom] No se encontró tramo para:', quantity);
            return;
        }
        // console.log(activeBreak);
        updateVolumeDiscountBadge(activeBreak.discount);
        /*
         * ============================================================
         * ACTUALIZAR PRECIO PDP
         * ============================================================
         */
        updateProductPrice(activeBreak);
        /*
         * ============================================================
         * NUEVO:
         * ACTUALIZAR TOTAL
         * ============================================================
         */
        updateQuantityBreakTotal(quantity, activeBreak.price);
        /*
         * ============================================================
         * MOSTRAR MENSAJE SI YA ESTÁ EN CARRITO
         * ============================================================
         */
        if (cartQuantity > 0) {
            showCartQuantityMessage(quantity, activeBreak.price);
        }
    }
    /*
     * ============================================================
     * NUEVO:
     * TOTAL ESTIMADO
     * ============================================================
     */
    function updateQuantityBreakTotal(quantity, price) {
        const infoList = document.querySelector('.product-form__info-list');
        if (!infoList) {
            return;
        }
        /*
         * Buscar la fila de Stock.
         * Queremos poner el total inmediatamente después.
         */
        const infoItems = infoList.querySelectorAll('.product-form__info-item');
        let stockItem = null;
        infoItems.forEach(function(item) {
            const title = item.querySelector('.product-form__info-title');
            if (title && title.textContent.trim().toLowerCase().includes('stock')) {
                stockItem = item;
            }
        });
        if (!stockItem) {
            return;
        }
        /*
         * Buscar si ya existe nuestro bloque.
         */
        let totalItem = infoList.querySelector('.qb-volume-total');
        /*
         * Crear solamente una vez.
         */
        if (!totalItem) {
            totalItem = document.createElement('div');
            totalItem.className = 'product-form__info-item qb-volume-total';
            totalItem.innerHTML = `
                <span class="product-form__info-title text--strong">
                    Total por cantidad:
                </span>

                <div class="product-form__info-content">
                    <strong class="qb-price-total"></strong>
                </div>
            `;
            /*
             * Insertar después de Stock
             */
            stockItem.insertAdjacentElement('afterend', totalItem);
        }
        /*
         * Calcular total.
         */
        const total = Math.round(quantity * price);
        /*
         * Actualizar cantidad en el título.
         */
        const title = totalItem.querySelector('.product-form__info-title');
        if (title) {
            title.textContent = `Total por ${quantity} Un.:`;
        }
        /*
         * Actualizar precio.
         *
         * Dejamos la clase qb-price-total para que
         * tu CSS de +IVA pueda actuar sobre este elemento.
         */
        const priceElement = totalItem.querySelector('.qb-price-total');
        if (priceElement) {
            priceElement.textContent = formatPrice(total);
        }
    }
    /*
     * ============================================================
     * MENSAJE PRODUCTO YA EN CARRITO
     * ============================================================
     */
    function showCartQuantityMessage(quantity, price) {
        const selector = document.querySelector('.colmain_qty');
        if (!selector) {
            return;
        }
        /*
         * ============================================================
         * SI YA EXISTE EL MENSAJE
         * ============================================================
         */
        let message = document.querySelector('.qb-cart-quantity-message');
        if (message) {
            /*
             * Actualizar cantidad
             */
            const quantityElement = message.querySelector('.qb-cart-current-quantity strong');
            if (quantityElement) {
                quantityElement.textContent = `${quantity} Un.`;
            }
            /*
             * Actualizar total
             */
            const totalElement = message.querySelector('.qb-cart-current-total strong');
            if (totalElement) {
                totalElement.textContent = formatPrice(Math.round(quantity * price));
            }
            return;
        }
        /*
         * ============================================================
         * OCULTAR SELECTOR
         * ============================================================
         */
        selector.style.display = 'none';
        /*
         * Crear mensaje
         */
        message = document.createElement('div');
        message.className = 'qb-cart-quantity-message';
        const total = Math.round(quantity * price);
        message.innerHTML = `
            <div class="qb-cart-quantity-text">
                <strong>Producto ya agregado al carro</strong>
                <span>La cantidad de este producto se administra desde el carro de compras.</span>
                <div class="qb-cart-summary">
                    <div class="qb-cart-summary-row">
                        <span>Añadido al carrito:</span>
                        <strong>${quantity} Un.</strong>
                    </div>
                    <div class="qb-cart-summary-row">
                        <span>Subtotal:</span>
                        <strong class="qb-cart-current-total qb-price-total">${formatPrice(total)}</strong>
                    </div>
                </div>
            </div>
            <a href="/cart" class="button button--primary qb-cart-button">Ir al carro</a>
        `;
        selector.parentNode.insertBefore(message, selector);
    }
    /*
     * ============================================================
     * OBTENER CANTIDAD DEL CARRITO
     * ============================================================
     */
    function getCartQuantity() {
       /*
         * ============================================================
         * VERIFICA SI YA EXISTE EL CONTENEDOR Y OBTIENE LA CANTIDAD
         * ============================================================
         */        
        const cartContainer = document.querySelector('.product-form__payment-container .mini-cart__quantity');
        if (cartContainer && cartContainer.style.display !== 'none') {
            const cartInput = cartContainer.querySelector('.qty_inpt');
            if (cartInput) {
                const currentValue = parseInt(cartInput.dataset.currentValue || cartInput.value || '0', 10) || 0;
                return currentValue;
            }
        }
        return 0;
    }
    /*
     * ============================================================
     * ACTUALIZAR PRECIO PDP
     * ============================================================
     */
    function updateProductPrice(activeBreak) {
        const $priceList = $('.product-form__info-content .price-list');
        if (!$priceList.length) {
            return;
        }
        let $price = $priceList.find('.price').first();
        if (!$price.length) {
            return;
        }
        /*
         * Precio original de la PDP.
         * Lo guardamos una sola vez.
         */
        let originalPrice = $price.attr('data-qb-original-price');
        if (!originalPrice) {
            originalPrice = normalizePrice($price.text());
            if (!Number.isNaN(originalPrice)) {
                $price.attr('data-qb-original-price', originalPrice);
            }
        }
        originalPrice = Number(originalPrice);
        /*
         * ============================================================
         * EXISTE DESCUENTO
         * ============================================================
         */
        if (activeBreak.price < originalPrice) {
            $price.addClass('price--highlight').text(formatPrice(activeBreak.price));
            let $compare = $priceList.find('.price--compare').first();
            if (!$compare.length) {
                $compare = $('<span class="price--compare"></span>');
                $price.after($compare);
            }
            $compare.text(formatPrice(originalPrice)).show();
        }
        /*
         * ============================================================
         * SIN DESCUENTO
         * ============================================================
         */
        else {
            $price.removeClass('price--highlight').text(formatPrice(originalPrice));
            const $compare = $priceList.find('.price--compare').first();
            if ($compare.length) {
                $compare.remove();
            }
        }
    }
    /*
     * ============================================================
     * MARCAR TRAMO ACTIVO
     * ============================================================
     */
    function updateTableActiveRow(activeBreak) {
        quantityBreaks.forEach(function(item) {
            item.row.classList.toggle('active', item === activeBreak);
        });
    }
    /*
     * ============================================================
     * MUTATION OBSERVER
     * ============================================================
     */
    function observeQuantityBreaks() {
        // console.log('[QB Custom] Iniciando MutationObserver');
        const observer = new MutationObserver(function(mutations) {
            /*
             * Si ya tenemos una tabla inicializada,
             * no necesitamos volver a buscarla.
             */
            if (initializedTable) {
                return;
            }
            const table = findQuantityBreaksTable();
            if (!table) {
                return;
            }
            // console.log('[QB Custom] Tabla Quantity Breaks detectada');
            init(table);
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        /*
         * Revisar inmediatamente por si la app
         * ya cargó la tabla.
         */
        const existingTable = findQuantityBreaksTable();
        if (existingTable) {
            // console.log('[QB Custom] Tabla ya existente al iniciar');
            init(existingTable);
        }
    }
    /*
     * ============================================================
     * START
     * ============================================================
     */
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeQuantityBreaks);
    } else {
        observeQuantityBreaks();
    }
    /*
     * ============================================================
     * ACTUALIZAR SPAN .product-offer-icon CON % DE DESCUENTO
     * ============================================================
     */
    function updateVolumeDiscountBadge(discount) {
        /*
         * Buscar el producto actual en el PDP
         */
        const productForm = document.querySelector('form.product-form[data-productid]');
        if (!productForm) {
            // console.log('[QB Custom] No se encontró product-form');
            return;
        }
        const productId = productForm.dataset.productid;
        if (!productId) {
            // console.log('[QB Custom] No se encontró productId');
            return;
        }
        const productTitle = productForm.querySelector('.product-meta__title');
        /*
         * Buscar SOLO el badge correspondiente
         * al producto actual.
         */
        const badge = document.querySelector('.product-offer-icon[data-id="' + productId + '"]');
        if (!badge) {
            // console.log('[QB Custom] No se encontró badge para producto:', productId);
            return;
        }
        const p = badge.querySelector('p');
        if (!p) {
            return;
        }
        /*
         * ============================================================
         * SIN DESCUENTO
         * ============================================================
         */
        if (!discount || discount <= 0) {
            /*
             * Solo modificar si realmente es necesario.
             */
            if (p.textContent !== '0%') {
                p.textContent = '0%';
            }
            if (badge.classList.contains('is-visible')) {
                badge.classList.remove('is-visible');
                badge.classList.remove('qb-badge-discount');
            }
            if (productTitle) {
                productTitle.classList.remove('qb-has-discount');
            }
            return;
        }
        /*
         * ============================================================
         * CON DESCUENTO
         * ============================================================
         */
        const discountText = '-' + discount + '%';
        /*
         * Solo actualizar el texto si cambió.
         */
        if (p.textContent !== discountText) {
            p.textContent = discountText;
        }
        /*
         * Solo agregar la clase si todavía no existe.
         */
        if (!badge.classList.contains('is-visible')) {
            badge.classList.add('is-visible');
            badge.classList.add('qb-badge-discount');
        }
        if (productTitle) {
            productTitle.classList.add('qb-has-discount');
        }
        // console.log('[QB Custom] Descuento actualizado:', productId, discountText);
    }
})();